import * as t from "io-ts"

export const TFlightReport = t.interface({
  reportName: t.string,
  reportContents: t.string
})

export const TFlightReports = t.array(TFlightReport)
export const TFlightReportResult = t.interface({
  flightReports: TFlightReports
})

export type FlightReport = t.TypeOf<typeof TFlightReport>
export type FlightReports = t.TypeOf<typeof TFlightReports>
